import { useContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { userMenuMobileOverrideCSS } from './styles/UserMenuMobile.styles';
import UserMenu from './UserMenu';
import AppContext from '../../../../common/containers/AppContext';
import OverlayContext from '../../../../common/containers/OverlayContext';
import { BREAKPOINTS } from '../../../../common/services/breakpoints';

export default function UserMenuMobile() {
    const { setOverlay } = useContext(OverlayContext);
    const { user } = useContext(AppContext);
    const location = useLocation();
    const previousPathname = useRef(location.pathname);
    const isAboveSizeThreshold = useMediaQuery({ minWidth: BREAKPOINTS.SMALL.min });
    useEffect(() => {
        if (isAboveSizeThreshold) {
            setOverlay(null);
        }
    }, [isAboveSizeThreshold, setOverlay]);

    useEffect(() => {
        if (previousPathname.current !== location.pathname) {
            setOverlay(null);
        }
    }, [location.pathname, setOverlay]);

    const handleMenuItemClick = () => setOverlay(null);

    return (
        <UserMenu
            css={userMenuMobileOverrideCSS}
            email={user.email}
            onMenuItemClick={handleMenuItemClick}
            profileImageUrl={user.profileImageUrl}
            admin={user.admin}
        />
    );
}
